// Debug menu and action items that can be added to any menu (used in header-toolbar right now).
import GroupCache from '@/groups';
import { SchemaCache } from '@/schemas';
import appInfo from '@/app-info';
import Auth from '@/auth';

// Clear all local storage, or if we are in a local enviroment, just the prefixed keys.
function debugClearLocalStorage() {
	if (window.location.hostname.trim().toLowerCase() === 'localhost' || window.location.hostname.trim() === '127.0.0.1') {
        for (var key in localStorage) {
            if (key.startsWith(appInfo.localPrefix)) {
                localStorage.removeItem(key);
            }
        }
        console.log("Local storage (prefix) cleared.");
    } else {
        localStorage.clear();
        console.log("Local storage cleared.");
    }
}

// Damage local auth token to simulate auth failure. Can be done either in localStorage, or in actual App instance.
function mangleLocalAuthToken() {
    const existingToken = localStorage.getItem(appInfo.localPrefix + 'Auth');
    const mangledToken = existingToken ? existingToken.slice(0, -10) + '1234567890' : '';
    if (!mangledToken)
        alert("Warning: no existing token found in localStorage!");

    if (confirm("Mangle auth token in localStorage?")) {
        localStorage.setItem(appInfo.localPrefix + 'Auth', mangledToken);
    }
    if (confirm("Mangle auth token in App/RAM instance and reset headers?")) {
        Auth['_token'] = mangledToken;
        Auth.resetHttpHeaders();
    }
}

// Login with fixed debug credentials and refresh window.
async function debugLoginFixedCredentials() {
    // Default test values for login credentials -- should match values in backend app\Console\Setup.php
    const TEST_DEFAULTS = { 'name': 'admin', 'email': 'admin@cirii.org', 'password': 'admin123' };
    await Auth.logOut();
    await Auth.logIn(TEST_DEFAULTS.email, TEST_DEFAULTS.password);
    window.location.reload();
}

const DebugMenu = {
    text: "Debug menu",
    icon: "sun",
    items: [
		{ text: 'Group cache', items: [
            { text: "Force refresh", onClick: () => GroupCache.fetchGroupList() },
            { text: 'Dump to console', onClick: () => console.log(GroupCache.getCacheRef().value) },
        ]},
        { text: "Schema cache", items: [
            { text: "Force refresh", onClick: () => SchemaCache.fetchSchemaList() },
            { text: 'Dump to console', onClick: () => console.log(SchemaCache.getAllSchemas(true)) },
        ]},
        { text: "Mangle local auth token", onClick: () => mangleLocalAuthToken() },
        { text: "Force login with debug auth", onClick: () => debugLoginFixedCredentials() },
		{ text: "Clear local storage", onClick: () => debugClearLocalStorage() },
	],
};

export { DebugMenu };
